/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2018, 2019
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import React, { Component } from 'react';
import PropTypes from 'util/PropTypes';


import './CompareTable.scss';


import { Select, TruncatedText } from 'ca-ui-toolkit';
import CSSTransition from 'react-transition-group/CSSTransition';


/**
*/
export default class CompareTableDetailHeader extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const header = this.props.header;
		const _filler = this.props.filler;
		const col = this.props.column;

		if( header.type === 'ChartDetail') {
			let subHeader = null;

			let headerMarkup = null;
			if( header && header.list.length > 1 ){
				const selected = header.selected;
				const selectStyle = {
					width: '100%',
					'text-align': 'right'
				};
				headerMarkup = (
					<div data-tid={col} className="compareTable__header compareTable--rightAlign" key={col}>
						<Select
							size={'small'}
							variant= {'frameless'}
							options={header.list}
							selected={selected}
							style={ selectStyle }
							onChange={this.onChange.bind(this, header)} />
					</div>);
			} else {
				headerMarkup = (
					<div className="compareTable__header compareTable--rightAlign">
						<TruncatedText role="columnheader"  value={header.list[0].label}/>
					</div>
				);
			}

			if(header.subHeader) {
				subHeader = (
					<div className="compareTable__subHeader compareTable__subHeader--divider">
						<CSSTransition
							in={true}
							appear={true}
							timeout={500}
							classNames="compareTable__subHeaderItem1"
						>
							<div className="compareTable__subHeaderItem1">
								<TruncatedText  value={header.subHeader[0]}/>
							</div>
						</CSSTransition>
						<div className="compareTable__subHeaderItem2"></div>
					</div>);
			}

			const filler = !subHeader ? _filler : null;

			return (
				<div className="compareTable__detailHeaderContainer">
					{filler}
					{headerMarkup}
					{subHeader}
				</div>
			);
		}
		return null;
	}

	onChange(header, v){
		header.onChange(v);
	}
}

CompareTableDetailHeader.propTypes = {
	header: PropTypes.object,
	filler: PropTypes.object,
	column: PropTypes.number
};



// WEBPACK FOOTER //
// ./src/js/components/lwstats/CompareTableDetailHeader.js